import { times } from 'lodash-es';
import { Case, CaseLog } from '@/api/apis/case';
import { CaseLogCard } from './CaseLogCard';

type CaseLogTabProps = {
  caseData: Case;
  logs: CaseLog[];
  isLoading?: boolean;
};

export const CaseLogTab = ({ caseData, logs, isLoading }: CaseLogTabProps) => {
  return (
    <div className="flex min-h-full">
      <div className="flex flex-1 flex-col gap-4">
        {logs.map((log) => (
          <CaseLogCard key={`${log.eventType}_${log.createdAt}`} data={log} caseData={caseData} />
        ))}
        {isLoading && times(6, (i) => <CaseLogCard.Skeleton key={i} />)}
      </div>
    </div>
  );
};
